<!-- Created by 337547038 on 2021/1. -->
<template>
  <Container class="contact-body" :isHeaderWhite="isHeaderWhite" :isShowContent="isShowContent" :pageName="pageName">
    <div class="content">
        <img :src="$getImageUrl(imgSrc)" v-if="imgSrc&&false" >
           <div class="title" :class="'title-'+getLanguageName">{{contactTitle}}</div>
          <div class="text"  v-html="$textareaFormatter(contactContent)"></div>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: "contact",
  data() {
    return {
      contactModel:[],
      isHeaderWhite:true,

      imgSrc:'',
      isShowContent:false,
      pageName:'contact',
      contactTitle:'',
      contactContent:'',
    }
  },
  props: {},
  components: {Container},
  methods: {
    getData(){

      this.model = []
  
    
      this.$request.get("/contact").then((res)=>{

      //  this.isLoadingShow = false

        if (res.data.code === 0) {
            this.contactModel= res.data.data;

          this.$nextTick(() => {             
              this.changeData()
          }); 


          
        } 

        this.isShowContent = true


      
      })
    },

    changeData(){

      if(this.contactModel){

         if(this.$store.state.language.name==='cn'){

           this.imgSrc = this.contactModel.ContactPic
           this.contactTitle= this.contactModel.ContactTitle
           this.contactContent = this.contactModel.ContactContent
         }else{
           this.imgSrc = this.contactModel.ContactPicEn
           this.contactTitle= this.contactModel.ContactTitleEn
           this.contactContent = this.contactModel.ContactContentEn
         }
      
      }

     
     // this.getPlaceholder()
    },



  },
  computed: {

    
    getLanguageName(){
        return this.$store.state.language.name
    },

  },
  mounted() {

    this.getData()
  },
    watch:{

    getLanguageName(){

      this.changeData()

    },

  


  }  
}
</script>
